module.exports = __webpack_public_path__ + "static/media/right_arrow_white.ec8ee74b.svg";